var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "div",
        { staticClass: "contact-form", attrs: { id: "details" } },
        [
          _vm._m(0),
          _c("title-view", { attrs: { variant: "small" } }, [
            _vm._v("\n      " + _vm._s(_vm.$t("contact_10")) + "\n    ")
          ]),
          _c(
            "form",
            {
              staticClass: "grid",
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.submitContact.apply(null, arguments)
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "col-4_sm-12" },
                [
                  _c("input-label-view", {
                    attrs: { label: "contact_5" },
                    model: {
                      value: _vm.name,
                      callback: function($$v) {
                        _vm.name = $$v
                      },
                      expression: "name"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-4_sm-12" },
                [
                  _c("input-label-view", {
                    attrs: { type: "email", label: "contact_6" },
                    model: {
                      value: _vm.email,
                      callback: function($$v) {
                        _vm.email = $$v
                      },
                      expression: "email"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-4_sm-12" },
                [
                  _c("input-label-view", {
                    attrs: { type: "tel", label: "contact_7" },
                    model: {
                      value: _vm.phone,
                      callback: function($$v) {
                        _vm.phone = $$v
                      },
                      expression: "phone"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c("input-text-view", {
                    attrs: { label: "contact_8" },
                    model: {
                      value: _vm.message,
                      callback: function($$v) {
                        _vm.message = $$v
                      },
                      expression: "message"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c("input-checkbox-view", {
                    class: {
                      hasError: !_vm.rgpdConcent && _vm.hasMissingConcent
                    },
                    attrs: {
                      variant: "inverted",
                      type: "checkbox",
                      label: "rgdp_concent"
                    },
                    on: { updateValue: _vm.updateRgpdConcent },
                    model: {
                      value: _vm.rgpdConcent,
                      callback: function($$v) {
                        _vm.rgpdConcent = $$v
                      },
                      expression: "rgpdConcent"
                    }
                  })
                ],
                1
              ),
              _c(
                "button-view",
                { attrs: { type: "submit", variant: "center special" } },
                [_vm._v("\n        " + _vm._s(_vm.$t("button_1")) + "\n      ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "message-view",
        { attrs: { show: _vm.show } },
        [
          _c("template", { slot: "title" }, [
            _vm._v("\n      " + _vm._s(_vm.$t("message_3")) + "\n    ")
          ]),
          _c("template", { slot: "message" }, [
            _vm._v("\n      " + _vm._s(_vm.$t("message_4")) + "\n    ")
          ]),
          _c(
            "template",
            { slot: "action" },
            [
              _c(
                "button-view",
                {
                  attrs: { type: "submit", variant: "center special" },
                  nativeOn: {
                    click: function($event) {
                      _vm.show = false
                    }
                  }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("message_6")) + "\n      "
                  )
                ]
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", { staticClass: "contact-form__image" }, [
      _c("picture", [
        _c("source", {
          attrs: {
            media: "--large",
            "data-srcset":
              "/static/images/banner.jpg,\n          /static/images/banner@2x.jpg 2x,\n          /static/images/banner@3x.jpg 3x"
          }
        }),
        _c("img", {
          staticClass: "lazyload",
          attrs: {
            "data-sizes": "auto",
            "data-src": "/static/images/banner.jpg"
          }
        })
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-294d1792", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-294d1792","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contact/contact-form-view.vue
// module id = 588
// module chunks = 29